import "./tracking-cell.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import {
	minus,
	navigationPointer_01,
} from "@tql/ui-components-react/untitled/icons";

import type { Load } from "~/shared/schemas/loads-schema";

export const TrackingCell = <T extends Load>({
	...gridProps
}: GridCustomCellProps) => {
	const dataItem = gridProps.dataItem as T;

	// Guard against undefined dataItem
	if (!dataItem) {
		return <td {...gridProps.tdProps}></td>;
	}

	const statusClassMap = {
		DISPATCHED: "dispatched",
		PICKED_UP: "picked-up",
		DELIVERED: "delivered",
	};

	const setClassName = () => {
		return (
			statusClassMap[dataItem.loadStatus as keyof typeof statusClassMap] || null
		);
	};

	return (
		<td {...gridProps.tdProps}>
			<SvgIcon
				className={`tracking-icon ${setClassName()} ${dataItem.isImmediateAction ? "needs-attention" : ""} ${dataItem.isNeedsAcknowledged ? "needs-acknowledged" : ""}`}
				icon={dataItem.loadStatus === "PENDING" ? minus : navigationPointer_01}
				size={"large"}
			/>
		</td>
	);
};
